import React, { useState } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import WhatsAppButton from './components/layout/WhatsAppButton';

// Section Components
import HeroSection from './components/sections/HeroSection';
import ServicesSection from './components/sections/ServicesSection';
import PartnersSection from './components/sections/PartnersSection';
import AboutSection from './components/sections/AboutSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import ContactSection from './components/sections/ContactSection';

// Modal Components
import BookDemoModal from './components/modals/BookDemoModal';
import EnquiryModal from './components/modals/EnquiryModal';

const HomePage = () => {
  const [isBookDemoOpen, setIsBookDemoOpen] = useState(false);
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);

  const openBookDemo = () => setIsBookDemoOpen(true);
  const closeBookDemo = () => setIsBookDemoOpen(false);
  const openEnquiry = () => setIsEnquiryOpen(true);
  const closeEnquiry = () => setIsEnquiryOpen(false);

  return (
    <div className="min-h-screen bg-black">
      <Header onBookDemo={openBookDemo} />
      <main>
        <HeroSection onBookDemo={openBookDemo} onEnquiry={openEnquiry} />
        <PartnersSection />
        <ServicesSection onBookDemo={openBookDemo} />
        <AboutSection />
        <TestimonialsSection />
        <ContactSection onBookDemo={openBookDemo} onEnquiry={openEnquiry} />
      </main>
      <Footer />
      
      {/* WhatsApp Floating Button */}
      <WhatsAppButton />
      
      {/* Modals */}
      <BookDemoModal isOpen={isBookDemoOpen} onClose={closeBookDemo} />
      <EnquiryModal isOpen={isEnquiryOpen} onClose={closeEnquiry} />
      
      {/* Toast Notifications */}
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#121212',
            color: '#ffffff',
            border: '1px solid rgba(255,255,255,0.1)'
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
